export default {
  /* HeaderSettings/index.vue */
  'Apply': 'Aplicar',
  'Apply and backup settings to local': 'Aplicar y hacer copias de seguridad de la configuración en local',
  'Clear local settings backup and restore': 'Borrar copia de seguridad y restauración de la configuración local',
  'Using local settings': 'Usando la configuración local',

  /* Table/TableBody.vue */
  'No Data': 'Sin datos',

  /* index.vue */
  'Total': 'Total',
  ',': '，',

  /* PageSizeSelect.vue */
  'items / page': 'artículos / página'
}
